// Promise-based confirm dialog. Replaces native confirm() with a brand-consistent modal.
// Usage:
//   import { confirm } from '$lib/stores/confirm.svelte';
//   const ok = await confirm.ask({
//     title: 'Supprimer cette séance ?',
//     body: 'Cette action est définitive.',
//     confirmLabel: 'Supprimer',
//     danger: true
//   });
//   if (!ok) return;

export interface ConfirmOptions {
	title: string;
	body?: string;
	confirmLabel?: string;
	cancelLabel?: string;
	danger?: boolean;
}

interface ConfirmState extends ConfirmOptions {
	open: boolean;
	resolve: ((ok: boolean) => void) | null;
}

let _state = $state<ConfirmState>({
	open: false,
	title: '',
	body: undefined,
	confirmLabel: undefined,
	cancelLabel: undefined,
	danger: false,
	resolve: null
});

function ask(options: ConfirmOptions): Promise<boolean> {
	return new Promise<boolean>((resolve) => {
		// If a previous confirm is still open, resolve it as cancelled before opening the new one.
		if (_state.open && _state.resolve) {
			_state.resolve(false);
		}
		_state = {
			open: true,
			title: options.title,
			body: options.body,
			confirmLabel: options.confirmLabel,
			cancelLabel: options.cancelLabel,
			danger: !!options.danger,
			resolve
		};
	});
}

function answer(ok: boolean) {
	const r = _state.resolve;
	_state = { ..._state, open: false, resolve: null };
	r?.(ok);
}

export const confirm = {
	get state(): ConfirmState {
		return _state;
	},
	ask,
	confirm: () => answer(true),
	cancel: () => answer(false)
};
